import NextIcon from '@src/assets/images/common/icon/files/next-icon.svg';
import PrevIcon from '@src/assets/images/common/icon/files/prev-icon.svg';
import { ChatAttachmentListProps } from '@src/features/shared/community/components/chat/chatList/ChatAttachmentList';
import ChatFileItem from '@src/features/shared/community/components/chat/chatList/ChatFileItem';
import Tooltip from '@src/features/shared/community/components/chat/Tooltip';
import { useScrollState } from '@src/hooks/useScrollState';
import useTooltip from '@src/hooks/useTooltip';
import { useEffect, useRef } from 'react';

// 画像以外のファイル（.pdfや.xlsx）のプレビューのリスト
const PreviewFileItemList = ({ attachments, chat, keyword }: ChatAttachmentListProps) => {
  const { showTooltip, displayTooltip } = useTooltip();
  const containerRef = useRef<HTMLDivElement>(null);
  const { scrollState, scroll, updateScrollState } = useScrollState(containerRef);

  useEffect(() => {
    updateScrollState();
  }, [attachments, updateScrollState]);

  return (
    <div className='relative h-[48px]'>
      <div
        ref={containerRef}
        className='flex h-[200%] justify-start gap-[10px] overflow-hidden'
      >
        {attachments?.map((attachment) =>
          attachment.chatAttachment ? (
            <div
              key={attachment.chatAttachment?.id}
              className='h-[120px]  md:aspect-square md:h-auto '
            >
              <ChatFileItem
                key={attachment.chatAttachment.id}
                attachment={attachment.chatAttachment}
                chat={chat}
                showTooltip={showTooltip}
                displayTooltip={displayTooltip}
                keyword={keyword}
              />
            </div>
          ) : null,
        )}
      </div>
      {showTooltip && (
        <div className='absolute left-1/2 top-1/2 z-[999] w-[290px] -translate-x-1/2  -translate-y-1/2 text-[12px] lg:hidden'>
          <Tooltip
            label='ダウンロードするには、ログインしてください。'
            weight='500'
          />
        </div>
      )}
      {scrollState.canScrollNext || scrollState.canScrollPrev ? (
        <>
          <button
            onClick={() => scroll('prev')}
            className={`${scrollState.canScrollPrev ? '' : 'hidden'} absolute -left-3 top-1/2 z-10 -translate-y-1/2 rounded-full bg-white shadow transition-opacity duration-300`}
            aria-label='前へ'
          >
            <img
              width={24}
              height={24}
              src={PrevIcon}
              alt=''
              className='size-6 object-contain'
            />
          </button>
          <button
            onClick={() => scroll('next')}
            className={`${scrollState.canScrollNext ? '' : 'hidden'} absolute -right-3 top-1/2 z-10 -translate-y-1/2 rounded-full bg-white shadow transition-opacity duration-300`}
            aria-label='次へ'
          >
            <img
              width={24}
              height={24}
              src={NextIcon}
              alt=''
              className='size-6 object-contain'
            />
          </button>
        </>
      ) : null}
    </div>
  );
};

export default PreviewFileItemList;
